module.exports = __webpack_public_path__ + "img/equipment-badge.77c6324e.jpg";